export function MeshGradient() {
  return <div className="mesh-gradient" />;
}
